import './style.scss'

import React, { JSX, useRef, useState } from 'react'

import ArrowIcon from '../../../../assets/images/icons/arrow-button-icon.svg?react'
import DangerousIcon from '../../../../assets/images/icons/dangerous-goods.svg?react'
import DotIcon from '../../../../assets/images/icons/dot.svg?react'
import GeneralCargoIcon from '../../../../assets/images/icons/general-cargo.svg?react'
import HighValueIcon from '../../../../assets/images/icons/high-value.svg?react'
import AnimalIcon from '../../../../assets/images/icons/live-animal.svg?react'
import OversizedCargoIcon from '../../../../assets/images/icons/oversized-cargo.svg?react'
import PharmaIcon from '../../../../assets/images/icons/pharma.svg?react'
import SparePartsIcon from '../../../../assets/images/icons/spare-parts.svg?react'
import VehiclesIcon from '../../../../assets/images/icons/vehicles.svg?react'

export const SectionUserShipping = (): JSX.Element => {
    const sliderRef = useRef<HTMLDivElement>(null)
    const [page, setPage] = useState<number>(1)

    const scrollLeft = () => {
        sliderRef.current?.scrollBy({
            left: -sliderRef.current.clientWidth,
            behavior: 'smooth',
        })
    }

    const scrollRight = () => {
        sliderRef.current?.scrollBy({
            left: sliderRef.current.clientWidth,
            behavior: 'smooth',
        })
    }

    const handleScroll = () => {
        const slider = sliderRef.current
        if (!slider) return

        const currentPage = Math.round(slider.scrollLeft / slider.clientWidth) + 1
        setPage(currentPage)
    }

    const scrollToPage = (pageNumber: number) => {
        const slider = sliderRef.current
        if (!slider) return

        slider.scrollTo({
            left: slider.clientWidth * (pageNumber - 1),
            behavior: 'smooth',
        })
        setPage(pageNumber)
    }

    const shippings = [
        {
            icon: DangerousIcon,
            text: 'Dangerous goods',
        },
        {
            icon: AnimalIcon,
            text: 'Live animals',
        },
        {
            icon: GeneralCargoIcon,
            text: 'General cargo',
        },
        {
            icon: SparePartsIcon,
            text: 'Spare parts & AOG',
        },
        {
            icon: HighValueIcon,
            text: 'High-value & sensitive cargo',
        },
        {
            icon: VehiclesIcon,
            text: 'Vehicles',
        },
        {
            icon: OversizedCargoIcon,
            text: 'Oversized cargo',
        },
        {
            icon: PharmaIcon,
            text: 'Pharma & temperature-controlled cargo',
        },
    ]
    return (
        <div id="section-user-shipping" className="section-user-shipping">
            <div className="section-user-shipping__container">
                <div className="section-user-shipping__top">
                    <div className="section-user-shipping__section-title">
                        / What our users are shipping
                    </div>
                    <h2 className="section-user-shipping__title">
                        Every cargo type, handled by verified operators
                    </h2>
                </div>
                <div className="section-user-shipping__list-wrapper">
                    <ArrowIcon className="section-user-shipping__left-arrow" onClick={scrollLeft} />
                    <div
                        className="section-user-shipping__list"
                        ref={sliderRef}
                        onScroll={handleScroll}
                    >
                        {shippings.map((item) => {
                            const Icon = item.icon
                            return (
                                <div className="section-user-shipping__list-item" key={item.text}>
                                    <Icon />
                                    <div className="section-user-shipping__list-item-text">{item.text}</div>
                                </div>
                            )
                        })}
                    </div>
                    <ArrowIcon className="section-user-shipping__right-arrow" onClick={scrollRight} />
                    <div className="section-user-shipping__page">
                        <button
                            className="section-user-shipping__page-button"
                            type="button"
                            aria-label="Show cargo types page 1"
                            onClick={() => scrollToPage(1)}
                        >
                            <DotIcon className={page === 1 ? 'section-user-shipping__page-dot-active' : 'section-user-shipping__page-dot'} />
                        </button>
                        <button
                            className="section-user-shipping__page-button"
                            type="button"
                            aria-label="Show cargo types page 2"
                            onClick={() => scrollToPage(2)}
                        >
                            <DotIcon className={page === 2 ? 'section-user-shipping__page-dot-active' : 'section-user-shipping__page-dot'} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
